import { styled, Typography } from '@mui/joy'
import { myPalette } from '~/shared/lib/theme'

export const Title = styled(Typography)`
  font-weight: 500;
  font-size: 14px;
  color: ${myPalette.gray['600']};
`
